// eventListModel.js — 1:1 청구 반영 계약 목록의 상태 이름표·도우미 (2026-10-06 EventList.jsx 306줄에서 글자 그대로 분리)
import { fmtNum } from './monthlyCalculationUtils';

export const BASE_META = {
  pending: { label: '확인필요', tone: 'warn' },
  included: { label: '포함', tone: 'ok' },
  excluded: { label: '제외', tone: 'danger' },
  auto_included: { label: '자동포함', tone: 'ok' },
  auto_excluded: { label: '자동제외', tone: 'muted' },
  snapshot: { label: '확정기준', tone: 'muted' },
};

export const CANCEL_META = {
  pending: { label: '확인필요', tone: 'warn' },
  included: { label: '차감', tone: 'danger' },
  excluded: { label: '차감제외', tone: 'ok' },
  auto_included: { label: '차감', tone: 'danger' },
  auto_excluded: { label: '차감제외', tone: 'muted' },
  snapshot: { label: '확정기준', tone: 'muted' },
};

export function shortDate(value) {
  const text = String(value || '');
  return text.length >= 10 ? text.slice(5, 10).replace('-', '.') : '-';
}

export function signed(value) {
  const numberValue = Number(value || 0);
  return `${numberValue > 0 ? '+' : ''}${fmtNum(numberValue)}`;
}

export function statusFor(event, readOnly) {
  if (event.chargeDecisionStatus) return event.chargeDecisionStatus;
  return readOnly ? 'snapshot' : 'pending';
}

export function metaFor(event, status) {
  const source = event.type === 'cancel' ? CANCEL_META : BASE_META;
  return source[status] || source.pending;
}

export function eventTypeLabel(event) {
  return event.type === 'cancel' ? '취소' : '계약';
}

export function decisionOptions(event) {
  if (event.type === 'cancel') {
    return [['pending', '확인'], ['included', '차감'], ['excluded', '제외']];
  }
  return [['pending', '확인'], ['included', '포함'], ['excluded', '제외']];
}

export function editableStatus(status) {
  if (status === 'auto_included') return 'included';
  if (status === 'auto_excluded') return 'excluded';
  return ['pending', 'included', 'excluded'].includes(status) ? status : '';
}

export function sourceTextFor(event) {
  const source = String(event.chargeDecisionSource || '');
  if (source === 'manual') {
    const actor = event.chargeDecidedByName ? ` · ${event.chargeDecidedByName}` : '';
    return `직접처리${actor}`;
  }
  if (event.type === 'cancel' && source.startsWith('contract_cancel_')) return '계약취소 처리 기준';
  if (event.isReorder && event.reorderIncludedByMarketer) return '재계약이지만 1:1 담당자 계약이라 포함';
  if (source === 'auto_included') return '1:1 기간 안의 담당자 계약으로 자동 포함';
  if (source === 'auto_excluded') return '자동 제외 기준';
  return '';
}

export function amountText(event) {
  const delta = Number(event.weightedDelta || 0);
  const rawDelta = Number(event.rawWeightedDelta ?? event.weightedDelta ?? 0);
  return rawDelta !== delta ? `${signed(rawDelta)}→${signed(delta)}장` : `${signed(delta)}장`;
}

export function itemSummary(items = []) {
  if (!items.length) return '';
  return items.map((item) => {
    const name = item.name || '미지정';
    const qty = Number(item.qty || 0);
    const weighted = Number(item.weightedQty ?? qty);
    const counted = Number(item.countedWeightedQty ?? weighted);
    const base = `${name} ${fmtNum(Math.abs(qty))}장`;
    const weightedText = Math.abs(weighted) !== Math.abs(qty) ? `→${fmtNum(Math.abs(weighted))}장` : '';
    const excludedText = Math.abs(counted) !== Math.abs(weighted) ? `, 반영 ${fmtNum(Math.abs(counted))}장` : '';
    return `${base}${weightedText}${excludedText}`;
  }).join(' · ');
}

export function summaryFor(events) {
  return events.reduce((acc, event) => {
    const status = statusFor(event, false);
    acc.total += 1;
    acc.weighted += Number(event.weightedDelta || 0);
    if (status === 'pending') acc.pending += 1;
    if (status === 'excluded' || status === 'auto_excluded') acc.excluded += 1;
    return acc;
  }, { total: 0, weighted: 0, pending: 0, excluded: 0 });
}
